import React, { useEffect, useState } from 'react';
import { Progress, Button, Modal, ModalHeader, ModalFooter, ModalBody, Form, Row, Col, FormGroup, Label, Input, Collapse, UncontrolledCollapse, InputGroup } from 'reactstrap';
import { Accordion, AccordionSummary, AccordionDetails, CircularProgress, styled } from '@mui/material';

const AccordionStyle = styled({
    root: {
        border: '1px solid rgba(0, 0, 0, .125)',
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
        width: '800px'
    },
    expanded: {},
})(Accordion);

const AccordionSummaryStyle = styled({
    root: {
        backgroundColor: 'rgba(0, 0, 0, .03)',
        borderBottom: '1px solid rgba(0, 0, 0, .125)',
        marginBottom: -1,
        minHeight: 56,
        '&$expanded': {
            minHeight: 56,
        },
    },
    content: {
        '&$expanded': {
            margin: '12px 0',
        },
    },
    expanded: {},
})(AccordionSummary);

const AccordionDetailsStyle = styled((theme) => ({
    root: {
        flex: 0,
        display: 'block',
        padding: theme.spacing(2),
    },
}))(AccordionDetails);

const MissingDataConfigModal = (props) => {
    const [data, setData] = useState(null);
    const [changedData, setChangedData] = useState([]);
    const [headers, setHeaders] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedArea, setSelectedArea] = useState();

    let _headers = [];

    useEffect(() => {
        getMissingData();
    }, []);

    const getMissingData = async () => {
        const res = await fetch(window.location.protocol + '//' + window.location.host + '/api/configuration/mongo_db_schema_check');
        const result = await res.json();

        if (result)
            setData(result)

    }

    const saveFileData = async (area) => {
        setLoading(true)
        const data = {
            area,
            data: changedData
        }

        const res = await fetch(window.location.protocol + '//' + window.location.host + '/api/configuration/save_mongo_data', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        });

        await getMissingData();
        setLoading(false);
    }

    const toggleSelectedArea = (area) => {
        setSelectedArea(area);
    }

    const updateFile = (file, field, value) => {
        const update = changedData.find(elm => elm._id == file._id);
        if (update) {
            update[field] = value;
        } else {
            file[field] = value;
            changedData.push(file);
        }
    }

    const copyFieldValue = (file, area, field) => {
        const dataCopy = [...data[area]];
        let newData = [...changedData];
        const update = changedData.find(elm => elm._id == file._id);
        let value;

        if (update)
            value = update[field];

        for (let item of dataCopy) {
            let file = item.file;
            file[field] = value;
            newData.push(file);
        }

        setChangedData(newData);
    }

    if (data) {
        for (const area in data) {
            var items = data[area];
            var row = [];
            if (area == selectedArea) {
                items.forEach(item => {
                    let missingItems = [];
                    item.missing.forEach(missing => {
                        const updated = changedData.find(elm => elm._id == item.file._id);
                        missingItems.push(
                            <Col md={3}>
                                <FormGroup>
                                    <Label for="exampleEmail">
                                        {missing}
                                    </Label>
                                    <InputGroup>
                                        <Input
                                            id="exampleEmail"
                                            placeholder={missing}
                                            type="text"
                                            value={updated ? updated[missing] : item.file[missing]}
                                            onChange={(e) => {
                                                updateFile(item.file, missing, e.target.value);
                                            }}
                                        />
                                        <Button color="secondary" onClick={() => copyFieldValue(item.file, area, missing)}>
                                            Copy
                                        </Button>
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                        )
                    });
                    if (missingItems.length > 0)
                        row.push(<div>
                            {area == 'documentTypeConfig' &&
                                <Label style={{ fontSize: '14px' }}>
                                    {item.file.DocumentType}
                                </Label>
                            }
                            {area == 'fileMetaData' &&
                                <Label style={{ fontSize: '14px' }}>
                                    {item.file.DocumentRef + '-' + item.file.DocumentType}
                                </Label>
                            }
                            {area == 'users' &&
                                <Label style={{ fontSize: '14px' }}>
                                    {item.file.DocumentRef + '-' + item.file.DocumentType}
                                </Label>
                            }
                            {area == 'templates' &&
                                <Label style={{ fontSize: '14px' }}>
                                    {item.file.DocumentRef + '-' + item.file.DocumentType}
                                </Label>
                            }
                            <Row>
                                {missingItems}
                            </Row>
                        </div>)
                });
            }
            _headers.push(
                <AccordionStyle expanded={area == selectedArea} onChange={() => toggleSelectedArea(area)}>
                    <AccordionSummaryStyle aria-controls="panel1d-content" id="panel1d-header">
                        {area}
                    </AccordionSummaryStyle>
                    <AccordionDetailsStyle>
                        <>
                            {row}
                            <Button color="success" onClick={() => saveFileData(area)}>
                                {loading ?
                                    <CircularProgress style={{ width: '1.2rem', height: '1.2rem', borderWidth: '.1em' }} />
                                    :
                                    "Save"
                                }
                            </Button>
                        </>
                    </AccordionDetailsStyle>
                </AccordionStyle>
            );
        }
    }



    return (
        <Modal isOpen={props.visible} toggle={props.toggle} className='modal-dialog'>
            <ModalHeader>Missing Data Input</ModalHeader>
            <ModalBody>
                <>
                    {_headers}
                </>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={() => props.toggle()}>
                    Close
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default MissingDataConfigModal;